import { render, staticRenderFns } from "./DISCOBJECT.interface.component.vue?vue&type=template&id=99601aa2&"
import script from "./DISCOBJECT.interface.component.vue?vue&type=script&lang=js&"
export * from "./DISCOBJECT.interface.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports